module.exports = __webpack_public_path__ + "img/chrome-icon.b2bdccf4.png";